document.addEventListener("DOMContentLoaded", function () {
  const swiperWrapper = document.querySelector(".scrolling-info .swiper-wrapper");
  const slides = swiperWrapper.querySelectorAll(".swiper-slide");

  if (slides.length > 0) {
    for (let i = 0; i < 5; i++) {
      slides.forEach(slide => {
        let clone = slide.cloneNode(true);
        swiperWrapper.appendChild(clone);
      });
    }
  }

  var swiper = new Swiper(".scrolling-info", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 20, 
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,        
    freeMode: true,     
    freeModeMomentum: false,
  });
});

{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".logoSlider .swiper-wrapper"
        );
        const slide = swiperWrapper.querySelector(".swiper-slide");

        if (slide) {
            for (let i = 0; i < 10; i++) {
                let clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            }
        }

        var swiper = new Swiper(".logoSlider", {
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 3500,
            breakpoints: {
                575: {
                    slidesPerView: 0.55,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 1.1,
                    spaceBetween: 30,
                },
                // 1025: {
                //     slidesPerView: 1.1,
                //     spaceBetween: 40,
                // },
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".tstmSlider");
        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");
            new Swiper(slider, {
                effect: 'slide',
                speed: 1000,
                slidesPerView: 1,
                spaceBetween: 30,
                allowTouchMove: false,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
                breakpoints: {
                    575: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    768: {
                        spaceBetween: 15
                    },
                    1024: {
                        spaceBetween: 20,
                    },
                }
            });
        });
    };
    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".videoSliderReviews").forEach((slider, index) => {
        const wrapper = slider.querySelector(".swiper-wrapper");
        const slides = slider.querySelectorAll(".swiper-slide");

        const clones = parseInt(slider.dataset.cloneMultiplier, 1) || 1;

        for (let i = 0; i < clones; i++) {
            slides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
        }

        console.log(
            `Slider #${index + 1}: total slides ${wrapper.querySelectorAll(".swiper-slide").length}`
        );

        new Swiper(slider, {
            direction: "horizontal",
            loop: true,
            effect: 'slide',
            speed: 1000,
            centeredSlides: true,
            grabCursor: true,
            slidesPerView:3,
            spaceBetween:30,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                575: { slidesPerView: 1.2, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 15 },
                1024: { slidesPerView: 2.7, spaceBetween: 20 },
                1200: { slidesPerView: 3, spaceBetween: 20 },
                // 1200 : {slidesPerView: 3, spaceBetween: 30},
            },
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".prodCardSlider");

        MultipleSliders.forEach((slider, index) => {
            const prevArrow = slider.parentElement.querySelector(".prev");
            const nextArrow = slider.parentElement.querySelector(".next");

            new Swiper(slider, {
                effect: 'slide',
                speed: 1000,
                slidesPerView: 3,
                spaceBetween: 43,
                breakpoints: {
                    // 150: {
                    //     slidesPerView: 1.3,
                    //     spaceBetween: 10
                    // },
                    575:{
                       slidesPerView: 1.3,
                        spaceBetween: 10 
                    },
                    768: {
                        slidesPerView: 2.8,
                        spaceBetween: 15
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween:  15
                    },
                    // 1025: {
                    //     slidesPerView: 3,
                    //     spaceBetween: 20
                    // },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                },
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },
            });
        });
    };

    MultipleSlider();
});

// document.addEventListener("DOMContentLoaded", function () {
//     const MultipleSlider = () => {
//         const MultipleSliders = document.querySelectorAll(".Product_slider_recom");

//         MultipleSliders.forEach((slider, index) => {
//             const prevArrow = slider.parentElement.querySelector(".prev");
//             const nextArrow = slider.parentElement.querySelector(".next");

//             new Swiper(slider, {
//                 effect: 'slide',
//                 speed: 1000,
//                 slidesPerView: 4,
//                 spaceBetween: 30,
//                 breakpoints: {
//                     // 150: {
//                     //     slidesPerView: 1.3,
//                     //     spaceBetween: 10
//                     // },
//                     575:{
//                        slidesPerView: 1.3,
//                         spaceBetween: 10 
//                     },
//                     768: {
//                         slidesPerView: 2.8,
//                         spaceBetween: 15
//                     },
//                     1024: {
//                         slidesPerView: 3,
//                         spaceBetween:  15
//                     },
//                     // 1025: {
//                     //     slidesPerView: 3,
//                     //     spaceBetween: 20
//                     // },
//                     1200: {
//                         slidesPerView: 4,
//                         spaceBetween: 20
//                     },
//                 },
//                 navigation: {
//                     nextEl: nextArrow,
//                     prevEl: prevArrow,
//                 },
//             });
//         });
//     };

//     MultipleSlider();
// });

